module.exports = __webpack_public_path__ + "img/tel_img.8c0a3a25.png";